var grantedGDPR = function () {
  if (process.server) return false
  const getGDPR = localStorage.getItem('GDPR:accepted')
  return typeof getGDPR !== 'undefined' && getGDPR === 'true'
}

var identifyCio = function (data) {
  if (!window || !window._cio) return
  const email =
    typeof data === 'string' ? data : data && (data.email || data.id)
  if (!email) return
  window._cio.identify({ id: email, email: email })
}

var identifyAmplitude = function (data) {
  if (process.server || !window) return
  const email =
    typeof data === 'string' ? data : data && (data.email || data.id)
  if (!email) return
  import('@amplitude/analytics-browser')
    .then(({ Identify, identify, setUserId }) => {
      setUserId(email)
      const identifyEvent = new Identify()
      identifyEvent.set('email', email)
      identify(identifyEvent)
    })
    .catch(function () {})
}

var trackCio = function (event, data) {
  if (!window || !window._cio) return
  if (event === 'Product Viewed') return
  window._cio.track(event, data)
}

var trackAmplitude = function (event, data) {
  if (process.server || !window) return
  import('@amplitude/analytics-browser')
    .then(({ track }) => {
      track(event, data)
    })
    .catch(function () {})
}

var pageCio = function (data) {
  if (!window || !window._cio) return
  window._cio.page((data && data.path) || window.location.href)
}

export const state = () => ({
  accepted: false,
  buffer: []
})

export const getters = {
  getBuffer: (state) => {
    return state.buffer
  }
}

export const mutations = {
  SET_ACCEPTED(state, boolean) {
    state.accepted = boolean
  },
  ADD_TO_BUFFER(state, event) {
    state.buffer.push(event)
  }
}

export const actions = {
  init(state) {
    if (process.client) this.$initGaAnon()
    if (grantedGDPR()) {
      state.commit('SET_ACCEPTED', grantedGDPR())
      this.$initTracking()
    }
  },
  accept(state) {
    localStorage.setItem('GDPR:accepted', true)
    localStorage.setItem('GDPR:date', new Date())
    state.commit('SET_ACCEPTED', true)
    this.$initTracking()
  },
  identify(store, data) {
    if (!grantedGDPR()) return false
    window && window.analytics && window.analytics.identify(data)
    identifyCio(data)
    identifyAmplitude(data)
  },
  page({ commit, getters, rootGetters }, data) {
    if (!grantedGDPR()) return false
    window && window.analytics && window.analytics.page(data)
    pageCio(data)
  },
  track({ commit, getters, rootGetters }, { event, data }) {
    if (window && window._paq) {
      window._paq.push(['trackEvent', 'engagement', event, 'not set', data])
    }
    if (!grantedGDPR())
      return commit('ADD_TO_BUFFER', {
        event: event,
        data: data
      })
    window && window.analytics && window.analytics.track(event, data)
    trackCio(event, data)
    trackAmplitude(event, data)
  },
  playBuffer({ dispatch, getters, rootGetters }) {
    var promises = []
    getters.getBuffer.forEach((savedEvent) => {
      promises.push(dispatch('track', savedEvent))
    })

    return Promise.all(promises)
  }
}
